import { Observable } from 'rxjs';
export enum SurveyStatus {
  OPEN = 'OPEN',
  ACTIVE = 'ACTIVE',
  CLOSE = 'CLOSE',
}
